/**
 * Turns any API error into one readable message.
 * Handles { message }, express-validator { errors: [{ msg }] } and network errors.
 */
export const getErrorMessage = (err: any, fallback = "Something went wrong. Please try again."): string => {
    const data = err?.response?.data;

    if (Array.isArray(data?.errors) && data.errors.length) {
        const msgs = data.errors.map((e: any) => e?.msg || e?.message).filter(Boolean);
        if (msgs.length) return Array.from(new Set(msgs)).join(" · ");
    }

    if (typeof data?.message === "string" && data.message) return data.message;

    if (err?.code === "ERR_NETWORK") return "Cannot reach the server. Check your connection.";

    return fallback;
};

/**
 * Field-level errors from express-validator, keyed by field name
 * ({ errors: [{ path: "email", msg: "Invalid email" }] }).
 */
export const getFieldErrors = (err: any): Record<string, string> => {
    const list = err?.response?.data?.errors;
    const out: Record<string, string> = {};

    if (Array.isArray(list)) {
        for (const e of list) {
            const key = e?.path || e?.param;
            if (key && !out[key]) out[key] = e.msg || e.message;
        }
    }

    return out;
};